// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingOverlay_loading-container__8svyJ {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: var(--z-modal);
  border-radius: 0.8rem;
  background-color: #fff;
}

.LoadingOverlay_loading__-GzOZ {
  width: 20rem;
  height: 15rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/Loading/LoadingOverlay/LoadingOverlay.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":[".loading-container {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: var(--z-modal);\n  border-radius: 0.8rem;\n  background-color: #fff;\n}\n\n.loading {\n  width: 20rem;\n  height: 15rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading-container": `LoadingOverlay_loading-container__8svyJ`,
	"loading": `LoadingOverlay_loading__-GzOZ`
};
export default ___CSS_LOADER_EXPORT___;
